import { getRouteApi } from '@tanstack/react-router';

export const processDefinitionRouteApi = getRouteApi('/process-definition/$id');

export const useProcessDefinitionPrevLocation = () =>
    processDefinitionRouteApi.useSearch({
        select: ({ prevPath, prevSearch }) => ({ prevPath, prevSearch }),
    });

export const useProcessDefinitionIdParam = () =>
    processDefinitionRouteApi.useParams({ select: (params) => params.id });

export const useProcessDefinitionSiteContext = () =>
    processDefinitionRouteApi.useRouteContext({ select: (context) => context.site! });
